/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Toolbar_Secondary_Automatic_Transcription_TitleInputs */

const en_toolbar_secondary_automatic_transcription_title = /** @type {(inputs: Toolbar_Secondary_Automatic_Transcription_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Automatic Transcription`)
};

const fr_toolbar_secondary_automatic_transcription_title = /** @type {(inputs: Toolbar_Secondary_Automatic_Transcription_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Transcription Automatique`)
};

const de_toolbar_secondary_automatic_transcription_title = /** @type {(inputs: Toolbar_Secondary_Automatic_Transcription_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Automatische Transkription`)
};

const it_toolbar_secondary_automatic_transcription_title = /** @type {(inputs: Toolbar_Secondary_Automatic_Transcription_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trascrizione automatica`)
};

const ru_toolbar_secondary_automatic_transcription_title = /** @type {(inputs: Toolbar_Secondary_Automatic_Transcription_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Автоматическая транскрипция`)
};

const es_toolbar_secondary_automatic_transcription_title = /** @type {(inputs: Toolbar_Secondary_Automatic_Transcription_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Transcripción automática`)
};

const zh_cn2_toolbar_secondary_automatic_transcription_title = /** @type {(inputs: Toolbar_Secondary_Automatic_Transcription_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`自动转录`)
};

const ja_toolbar_secondary_automatic_transcription_title = /** @type {(inputs: Toolbar_Secondary_Automatic_Transcription_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`自動転写`)
};

const hi_toolbar_secondary_automatic_transcription_title = /** @type {(inputs: Toolbar_Secondary_Automatic_Transcription_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`स्वचालित प्रतिलेखन`)
};

const pt_pt2_toolbar_secondary_automatic_transcription_title = /** @type {(inputs: Toolbar_Secondary_Automatic_Transcription_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Transcrição automática`)
};

/**
* | output |
* | --- |
* | "Automatic Transcription" |
*
* @param {Toolbar_Secondary_Automatic_Transcription_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const toolbar_secondary_automatic_transcription_title = /** @type {((inputs?: Toolbar_Secondary_Automatic_Transcription_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Toolbar_Secondary_Automatic_Transcription_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_toolbar_secondary_automatic_transcription_title(inputs)
	if (locale === "de") return de_toolbar_secondary_automatic_transcription_title(inputs)
	if (locale === "it") return it_toolbar_secondary_automatic_transcription_title(inputs)
	if (locale === "ru") return ru_toolbar_secondary_automatic_transcription_title(inputs)
	if (locale === "es") return es_toolbar_secondary_automatic_transcription_title(inputs)
	if (locale === "zh-CN") return zh_cn2_toolbar_secondary_automatic_transcription_title(inputs)
	if (locale === "ja") return ja_toolbar_secondary_automatic_transcription_title(inputs)
	if (locale === "hi") return hi_toolbar_secondary_automatic_transcription_title(inputs)
	if (locale === "pt-PT") return pt_pt2_toolbar_secondary_automatic_transcription_title(inputs)
	return en_toolbar_secondary_automatic_transcription_title(inputs)
});